<a class="fx-row align-items-center justify-content-start mb-8" (click)='disabled ? null : back()'
  [class.disabled]="disabled">
  <mat-icon class="main mr-5" fontSet="material-icons-outlined">arrow_back</mat-icon>
  <span class="main text">{{('UTILS.BACK' | translate).toLowerCase()}}</span>
</a>